import { CardElement } from "@stripe/react-stripe-js";
import type { StripeCardElementChangeEvent } from "@stripe/stripe-js";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#32325d",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};

function CardSection({
  onChange,
}: {
  onChange: (event: StripeCardElementChangeEvent) => void;
}) {
  return (
    <CardElement
      options={CARD_ELEMENT_OPTIONS}
      className="form-control mb-2"
      onChange={onChange}
    />
  );
}
export default CardSection;
